// Vuex
import store from '@/store.js';
// i18n
import i18n from '@/i18n';
// Self-made Snackbar
import snackbar from '@/plugins/snackbar';
import consts from '@/consts.js'

import Request from './request';

async function imports(data, file) {// 导入
    store.dispatch("fullscreenLoading");
    const response = await Request('post',
        "api/return-orders/import",
        Object.assign({}, data, {
            excel: file
        }));// TODO TODEBUG
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Import.success", i18n.t("ReturnOrder.title")));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function fetch(data) {
    return Request('get', "api/return-orders", data);
}

async function exports(data) {// 导出报表
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/return-orders/export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function fetchOne(id, data) {// 获取单个
    return Request('get', "api/return-orders/" + id, data);
}

async function fetchRelations(id, data) {// 获取退货单相关单据
    return Request('get', "api/return-orders/relations/" + id, data);
}

function delSomeFields(data) {// 去除过多杂项
    data = JSON.parse(JSON.stringify(data));// 深拷贝避免修改原数据
    delete data.actions;
    delete data.shop;
    delete data.order_activities;
    delete data.bill;
    delete data.creater;
    return data;
}

async function add(data) {// 新建退货单
    data = delSomeFields(data);// 去除过多杂项
    return Request('post', "api/return-orders/add", data);
}

async function confirm(data) {// 确认退货单
    data = delSomeFields(data);// 去除过多杂项
    return Request('patch', "api/return-orders/confirm/" + data.id, data);
}

async function edit(data) {// 编辑退货单
    data = delSomeFields(data);// 去除过多杂项
    return Request('patch', "api/return-orders/edit/" + data.id, data);
}

async function redeliver(id) {// 重新分发退货单
    return Request('get', "api/return-orders/redeliver/" + id);
}

async function approve(id) {// 审核退货单
    return Request('get', "api/return-orders/approve/" + id);
}

async function cancel(id) {// 作废退货单
    return Request('get', "api/return-orders/cancel/" + id);
}

// 详情批量导出
async function batcEexportExcel(data) {
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/return-orders/batch-detail-export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function getReturnableView(id) {// 根据订单ID获取退货商品
    return Request('get', "api/return-orders/getReturnableView/" + id);
}

async function addPreview(data) {
    // 新建退货单单预览
    return Request('post', 'api/return-orders/add-view', data)
  }
  
  async function confirmPreview(data) {
    // 确认退货单预览
    return Request('patch', 'api/return-orders/confirm-view', data)
  }
  
  async function editPreview(data) {
    // 编辑退货单预览
    return Request('patch', 'api/return-orders/edit-view', data)
  }

async function batchApprove(data) {
    //批量审批
    return Request('get', 'api/return-orders/batch-approve', data, false, false, true)
}

async function batchConfirm(data) {
    //批量确认
    return Request('get', 'api/return-orders/batch-confirm', data, false, false, true)
}

async function returnOrderPrint(id) {
    //退货单打印
    return Request('get', 'api/return-orders/return-order-print/' + id)
}
async function returnOrdersPrint(data) {
    //退货单批量打印
    data.limit = consts.limitAll //获取全部
    data.itemsPerPage = consts.limitAll //获取全部
    return Request('get', 'api/return-orders/return-orders-print/', data)
}

async function detailExports(id) {
    // 导出退货报表
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/return-orders/export/'+id)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

async function getReturnableList(data) {
    return Request('get', "api/return-orders/get-returnable-list", data);
}

export default {
    imports,
    fetch, exports,
    fetchOne,
    fetchRelations,
    add,
    confirm,
    edit,
    redeliver, approve, cancel,
    batcEexportExcel,
    getReturnableView,
    addPreview,
    confirmPreview,
    editPreview,
    batchApprove,
    batchConfirm,
    returnOrderPrint,
    returnOrdersPrint,
    detailExports,
    getReturnableList,
};